import { TestShackPage } from "./TestShackPage";

export default TestShackPage;
